// 年龄段 -> 建存档时使用的代表年龄(具体是几岁不影响任何业务逻辑,
// 只是数据库 age 字段需要一个 6-12 之间的整数;真正驱动内容选择的是 age_band)。
export const AGE_BAND_REPRESENTATIVE_AGE = { '6-8': 7, '9-12': 10 };

// 找回存档时只有 age 整数,按此阈值派生 age_band —— 单一信息源,
// 前端其它地方都不应该自己再判断一遍"多大算 9-12"。
export function ageBandFromAge(age) {
  return age <= 8 ? '6-8' : '9-12';
}
